import angular from 'angular';
import template from './modal.component.html';
import './modal.repository.js';

angular
    .module('Toke')
    .component('appModal', {
        template,
        bindings: {
            data: '<'
        },
        controller: ModalController
    });

ModalController.$inject = ['modalRepository', '$timeout'];

function ModalController(modalRepository, $timeout) {

    const vm = this;

    vm.modalData = {};
    vm.isOpen = false;

    vm.open = open;
    vm.close = close;

    vm.$onInit = function () {

        const loadData = vm.data
            ? Promise.resolve(vm.data)
            : modalRepository.getModal();

        loadData.then(res => {
            vm.modalData = res;

            $timeout(() => {
                vm.open();
            });
        });
    };

    function open() {
        vm.isOpen = true;
    }

    function close() {
        vm.isOpen = false;
    }
}
